import { render, staticRenderFns } from "./NbCardLinkBrand.vue?vue&type=template&id=5dffa36a&scoped=true&"
import script from "./NbCardLinkBrand.vue?vue&type=script&lang=js&"
export * from "./NbCardLinkBrand.vue?vue&type=script&lang=js&"
import style0 from "./NbCardLinkBrand.vue?vue&type=style&index=0&id=5dffa36a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffa36a",
  null
  
)

export default component.exports